import useSWR from "swr"
import fetchDataService from "../services/fetchDataService"

export function useSales(tokenData:any,saleData:any,companyId:number){
  const {first,pending,company,status,documentType,page,hitsPerPage,createdBy,filter} = saleData
  const url = pending ? "/inventory/movement/get-pending-movements" : first ? "/inventory/movement/get-first-movement" : "/inventory/movement/get-movements"
  const startFilter = filter?.startDate || ''
  const endFilter = filter?.endDate || ''
  const swrKey = page === undefined 
    ? `${url}/${company}/${status}/${documentType}${createdBy ? `/${createdBy}` : ''}/${startFilter}/${endFilter}` 
    : `${url}/${company}/${status}/${documentType}/${page}/${hitsPerPage}${createdBy ? `/${createdBy}` : ''}/${startFilter}/${endFilter}`
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...saleData,csrfToken:tokenData?.token.uid})  
  const {data,error,isLoading,mutate} = useSWR(()=>(tokenData.key && company && companyId)  ? [swrKey,tokenData.token.uid]: null,fetcher,{keepPreviousData:true})
  return {
    data,
    error,
    isLoading,
    mutate
  }
}

export function usePosFetch(tokenData:any,posData:any,companyId:number){
  const {company,all} = posData
  const url = '/sale/pos/get-pos'
  const swrId = all ? "/bulk" : "/pos"
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...posData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && company && companyId)  ? [`${url}${swrId}/${company}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}

export function useSessionCashFetch(tokenData:any,posData:any,sessionData:any){
  const {company,all} = sessionData
  const url = '/sale/cash-session/get-session'
  const swrId = all ? "/bulk" : "/session"
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...sessionData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && posData?.pos && company)  ? [`${url}${swrId}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}

export function useCashRegisterFetch(tokenData:any,posData:any){
  const {company,all} = posData
  const url = '/sale/cash-register/get-cash-register'
  const swrId = all ? "/bulk" : "/cash-register"
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...posData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && company)  ? [`${url}${swrId}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}

export function useCurrentSessionCashFetch(tokenData:any,sessionData:any,companyId:number){
  const {company} = sessionData
  const url = '/sale/cash-session/get-current-session'
  const fetcher = () => fetchDataService.post(url,tokenData.key,{...sessionData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && company && companyId)  ? [`${url}/${company}`,tokenData.token.uid]: null,fetcher)
  return {
    data,
    error
  }
}